<template lang="pug">
// Content row
.vc-day-popover-row
    // Indicator
    .vc-day-popover-row-indicator(v-if='indicator')
        span(:style='indicator.style' :class='indicator.class')
    // Content
    .vc-day-popover-row-content
        slot(name='time')
            slot
                span.limited-width
                    component(:is="tag" v-bind="properties")
                        label(v-if="attribute.popover") {{ attribute.popover.label }}
                        label(v-else) Kein Inhalt
                    .small {{ span }}
            slot(name='actions')
</template>

<script>

import { format } from 'date-fns'
import { de } from 'date-fns/locale'

export default {
    name: 'CalendarPopoverRow',
    props: {
        attribute: Object,
    },
    computed: {
        indicator() {
            let indicator

            const { highlight, dot, bar, content, popover, customData } = this.attribute;
            if (popover && popover.hideIndicator) return null;
            if (dot) {
                const { color, isDark, style } = dot.start;

                let background = 'var(--red-500)'
                if (style && style.color) background = style.color

                indicator = {
                    class: `vc-bg-${color}-500`,
                    style: {
                        width: '5px',
                        height: '5px',
                        borderRadius: '50%',
                        background,
                    },
                };
            }
            else if (highlight) {
                const { color, isDark, style } = highlight.start;

                let background = 'var(--red-500)'
                if (style && style.color) background = style.color

                indicator = {
                    class: `vc-bg-${color}-500`,
                    style: {
                        width: '10px',
                        height: '5px',
                        borderRadius: '3px',
                        background,
                    },
                };
            }
            else if (bar) {
                const { color, isDark, style } = bar.start;

                let background = 'var(--red-500)'
                if (style && style.color) background = style.color

                indicator = {
                    class: `vc-bg-${color}-500`,
                    style: {
                        width: '10px',
                        height: '3px',
                        background,
                    },
                };
            }
            else if (content) {
                const { color, isDark, style } = content.start;

                let background = 'var(--red-500)'
                if (style && style.color) background = style.color

                indicator = {
                    class: `vc-bg-${color}-500`,
                    style: {
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        background,
                    },
                };
            }

            // if (customData && customData.booking) {
            //     indicator.style.width = '12px'
            //     indicator.style.height = '12px'
            // }

            return indicator;
        },
        span() {
            let start, end
            if (this.attribute.targetDate.daySpan === 0) {
                start = format(this.attribute.targetDate.start, 'HH:mm', { locale: de })
                end = format(this.attribute.targetDate.end, 'HH:mm', { locale: de })
            } else {
                start = format(this.attribute.targetDate.start, 'dd.MM.yy, HH:mm', { locale: de })
                end = format(this.attribute.targetDate.end, 'dd.MM.yy, HH:mm', { locale: de })
            }
            return `${start} - ${end}`
        },

        hyperlink() {
            return _.get(this.attribute.customData, 'slot.hyperlink') || {}
        },
        path() {
            let route

            if (this.hyperlink.type === 'post') {
                // category page

                const page = _.get(this.hyperlink, 'page')
                const categoryKey = _.get(page, 'category.key')
                const key = _.get(page, 'key')

                switch (categoryKey) {
                    case 'news':
                        route = `/aktuelles/${key}`
                        break;

                    case 'headerNews':
                        route = `/news/${key}`
                        break;

                    case 'events':
                        route = `/events/${key}`
                        break;
                    case 'archiv':
                        route = `/archiv/${key}`
                        break;


                }
            } else if (this.hyperlink.type === 'internal') {
                // menu item

                const menuItem = _.get(this.hyperlink, 'menuItem')
                route = _.get(menuItem, 'path')
            }

            return route
        },
        href() {
            let href

            if (this.hyperlink.type !== 'internal' && _.get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href
                switch (this.hyperlink.type) {
                    case 'external':
                        if (! _.startsWith(link, 'https://') && ! _.startsWith(link, 'http://')) href = `https://${link}`
                        else href = link
                        break;

                    case 'mailto':
                        href = `mailto:${link}`
                        break;

                    case 'tel':
                        href = `tel:${link}`
                        break;
                }
            }

            return href
        },
        tag() {
            let tag = 'div'
            if (this.path) tag = 'router-link'
            else if (this.href) tag = 'a'
            return tag
        },
        target() {
            return _.get(this.hyperlink, 'target') || '_self'
        },
        properties() {
            let properties

            if (this.path) {
                properties = {
                    to: this.path,
                }
            } else if (this.href) {
                properties = {
                    target: this.target,
                    href: this.href
                }
            } else {
                properties = {
                    class: 'no-link'
                }
            }

            return properties
        },
    },
};
</script>

<style lang="scss" scoped>
.vc-day-popover-row {
    --day-content-transition-time: 0.13s ease-in;
    display: flex;
    align-items: center;
    transition: all var(--day-content-transition-time);
    &:not(:first-child) {
        margin-top: 3px;
    }
}
.vc-day-popover-row-indicator {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 0;
    width: 10px;
    margin-right: 3px;
    & span {
        transition: all var(--day-content-transition-time);
    }
}
.vc-day-popover-row-content {
    display: flex;
    align-items: center;
    flex-wrap: none;
    flex-grow: 1;
    width: max-content;
}
.small {
    line-height: 1;
    font-size: 0.8em;
}
a {
    cursor: pointer !important;
}
</style>
